<template>
  <main class="substitution-container">
    <div
      class="substitution"
      v-for="sub in substitutions"
      @click="clickedSubstitution(sub)"
      :data-cy="dataCy(sub.label)"
    >
      + {{ sub.label }}
    </div>
  </main>
</template>

<script>
export default {
  name: "substitutions",
  props: {
    substitutions: Array
  },

  methods: {
    clickedSubstitution(sub) {
      this.$emit('updated:substitution', sub);
    },
    dataCy(sub){
      return `substitution-${sub.replaceAll(' ','-')}`
    }
  }
}
</script>

<style scoped>
  .substitution-container {
    background-color: #128ff9;
    cursor: pointer;
    border-radius: 16px;
    border-bottom-right-radius: 0px;
    max-width: 200px;
  }
  .substitution {
    display: flex;
    justify-content: center;
  }
</style>
